<template>
  <div class="infoCont" :style="{ backgroundColor: info.tips }">
    <div class="g-box">
      <EditCont :content="info.content" class="infoCont-bd" />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import EditCont from "../../components/EditCont";

export default {
  mixins: [pageMain_mx],
  data() {
    return {};
  },
  components: { EditCont },
  mounted() {},
  methods: {
    init() {
      this.params = this.$route.params;
      this.getInfo();
    }
  }
};
</script>
<style lang="less">
.infoCont {
  padding: 88px;
}
.infoCont-bd {
}
</style>
